/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do words like 'fire' or 'every' sometimes count wrong?`)
};

const es_syl_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué palabras como 'fire' o 'every' a veces se cuentan mal?`)
};

const de_syl_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum werden Wörter wie 'fire' oder 'every' manchmal falsch gezählt?`)
};

const nl_syl_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom worden woorden als 'fire' of 'every' soms verkeerd geteld?`)
};

const fr_syl_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi des mots comme 'fire' ou 'every' sont-ils parfois mal comptés ?`)
};

const it_syl_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché parole come 'fire' o 'every' a volte vengono contate in modo errato?`)
};

const pt_br2_syl_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que palavras como 'fire' ou 'every' às vezes são contadas incorretamente?`)
};

const pt_syl_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que razão palavras como 'fire' ou 'every' às vezes são contadas incorretamente?`)
};

const ja_syl_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「fire」や「every」のような単語が正しくカウントされないことがあるのはなぜですか？`)
};

const zh_syl_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么像“fire”或“every”这样的单词有时统计不准确？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_hub_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_hub_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_hub_faq3_q", locale)
	if (locale === "en") return en_syl_hub_faq3_q(inputs)
	if (locale === "es") return es_syl_hub_faq3_q(inputs)
	if (locale === "de") return de_syl_hub_faq3_q(inputs)
	if (locale === "nl") return nl_syl_hub_faq3_q(inputs)
	if (locale === "fr") return fr_syl_hub_faq3_q(inputs)
	if (locale === "it") return it_syl_hub_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_syl_hub_faq3_q(inputs)
	if (locale === "pt") return pt_syl_hub_faq3_q(inputs)
	if (locale === "ja") return ja_syl_hub_faq3_q(inputs)
	return zh_syl_hub_faq3_q(inputs)
};